import _jsx from "@babel/runtime/helpers/jsx";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import get from 'lodash/get';
import Typography from '@mui/material/Typography';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import VISMA_DOC_STATUSES from '../../../constants/vismaDocStatuses';
import s from './SignatureStatus.scss';
import intlPropTypes from '../../../constants/intlPropTypes';
var messages = defineMessages({
  pendingStatusMsg: {
    id: "SignatureStatus.pendingStatusMsg",
    defaultMessage: [{
      "type": 0,
      "value": "Digital Visma Sign Status: "
    }, {
      "type": 8,
      "value": "b",
      "children": [{
        "type": 0,
        "value": "Pending"
      }]
    }, {
      "type": 0,
      "value": ", the invitation to sign the certificate was sent to "
    }, {
      "type": 8,
      "value": "b",
      "children": [{
        "type": 1,
        "value": "signerEmail"
      }]
    }, {
      "type": 0,
      "value": " on "
    }, {
      "type": 8,
      "value": "b",
      "children": [{
        "type": 1,
        "value": "signInvitationDate"
      }]
    }]
  },
  canceledStatusMsg: {
    id: "SignatureStatus.canceledStatusMsg",
    defaultMessage: [{
      "type": 0,
      "value": "Digital Visma Sign Status: "
    }, {
      "type": 8,
      "value": "b",
      "children": [{
        "type": 0,
        "value": "Canceled"
      }]
    }, {
      "type": 0,
      "value": ", "
    }, {
      "type": 8,
      "value": "b",
      "children": [{
        "type": 1,
        "value": "signerEmail"
      }]
    }, {
      "type": 0,
      "value": " did not fulfill invitation to sign"
    }]
  }
});
var SignatureStatus = function SignatureStatus(props) {
  var vismaSign = props.cert.vismaSign;
  if (!get(vismaSign, 'signerEmail')) {
    return null;
  }
  if (vismaSign.status === VISMA_DOC_STATUSES.pending) {
    return /*#__PURE__*/_jsx(Typography, {
      className: s.signStatus,
      variant: "subtitle1"
    }, void 0, vismaSign.status === VISMA_DOC_STATUSES.pending && /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.pendingStatusMsg, {
      values: {
        signerEmail: vismaSign.signerEmail,
        signInvitationDate: moment(vismaSign.createDate).format('YYYY-MM-DD')
      }
    })), vismaSign.status === VISMA_DOC_STATUSES.cancelled && /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.canceledStatusMsg, {
      values: {
        signerEmail: vismaSign.signerEmail
      }
    })));
  }
  return null;
};
export default compose(injectIntl, withStyles(s))(SignatureStatus);